import { AmountInfoBoxLocalized } from '@components'

import { AmountInfoBoxesGroup } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useSalaryStatistics } from '../../hooks/useSalaryStatistics'
import * as Styled from './styles'

export const SalarySummary = (): ReactElement => {
  const { t } = useTranslation()
  const { statistics, isLoading } = useSalaryStatistics()

  const { averageTransfersLastYear = 0, totalTransfersThisYear = 0, employeeCount = 0 } = statistics || {}

  return (
    <Styled.SalarySummaryWrapper>
      <AmountInfoBoxesGroup loading={isLoading}>
        <AmountInfoBoxLocalized
          amount={totalTransfersThisYear}
          badgeLabel={t('salary.summary.total_transfers')}
          badgeColor="accent"
          currencyId="DKK"
        />
        <AmountInfoBoxLocalized
          amount={averageTransfersLastYear}
          badgeLabel={t('salary.summary.avarage_transfers')}
          badgeColor="success"
          currencyId="DKK"
        />
        <AmountInfoBoxLocalized
          amount={employeeCount}
          badgeLabel={t('salary.summary.employee_count')}
          badgeColor="warning"
        />
      </AmountInfoBoxesGroup>
    </Styled.SalarySummaryWrapper>
  )
}
